import Avatar from "components/base/Avatar";
import ThemeToggler from "components/common/ThemeToggler";
import { useAppContext } from "providers/AppProvider";
import { Dropdown, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import ProfileDropdownMenu from "./ProfileDropdownMenu";
import EmpresaSelector from "components/empresa/EmpresaSelector";
import { useBreakpoints } from "providers/BreakpointsProvider";
import { useUser } from "services/account";

const NavItems = () => {
  const {
    config: { navbarPosition },
  } = useAppContext();
  const { user } = useUser();

  const { breakpoints } = useBreakpoints();

  return (
    <div className="navbar-nav navbar-nav-icons flex-row">
      {breakpoints.up("lg") && (
        <Nav.Item>
          <EmpresaSelector />
        </Nav.Item>
      )}
      <Nav.Item>
        <ThemeToggler className="px-2" />
      </Nav.Item>
      <Nav.Item>
        <Dropdown autoClose="outside" className="h-100">
          <Dropdown.Toggle
            as={Link}
            to="#!"
            className="dropdown-caret-none nav-link pe-0 py-0 lh-1 h-100 d-flex align-items-center"
            variant=""
          >
            {user?.imageUrl ? (
              <Avatar variant="image" size="l" src={user.imageUrl}>
                {user?.nome?.charAt(0)}
              </Avatar>
            ) : (
              <Avatar variant="name" size="l">
                {user?.nome?.charAt(0)}
              </Avatar>
            )}
          </Dropdown.Toggle>
          <ProfileDropdownMenu />
        </Dropdown>
      </Nav.Item>
    </div>
  );
};

export default NavItems;
